import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {matchPath, useLocation} from 'react-router-dom'

import {
  InnerSideNav,
  InnerSideNavItem,
} from '~/components/layout/sideNavs/innerSideNav/InnerSideNav'
import {useNavigationType} from '~/hooks/useNavigationType'

type ReportsSidebarNavProps = {
  fullPath: string
  onClick: (id: string) => void
}

export const ReportsSidebarNav = ({
  fullPath,
  onClick,
}: ReportsSidebarNavProps) => {
  const {t} = useTranslation<string>()
  const location = useLocation()
  const {isPractitionerOnly} = useNavigationType()

  const navDataList = useMemo(
    () =>
      isPractitionerOnly
        ? [{id: 'patients', label: t('Weekly')}]
        : [
            {id: 'services', label: t('Services')},
            {id: 'patients', label: t('Weekly')},
            {id: 'patient', label: t('Patient')},
          ],
    [isPractitionerOnly, t],
  )

  const activeRouteId = useMemo(
    () =>
      navDataList
        .map(({id}) => matchPath(`${fullPath}${id}`, location.pathname) && id)
        .find((result) => !!result) || navDataList[0].id,
    [navDataList, fullPath, location.pathname],
  )

  return (
    <InnerSideNav>
      {navDataList.map((data) => (
        <InnerSideNavItem
          key={data.id}
          active={activeRouteId === data.id}
          onClick={() => onClick(data.id)}>
          {data.label}
        </InnerSideNavItem>
      ))}
    </InnerSideNav>
  )
}
